export default {
  "site.name": "哈哈漫画网",
  "site.slogan": "韩国漫画精选",
  "site.description": "为您推荐好看的韩国漫画，海量资源免费阅读",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.search": "搜索漫画...",
  "nav.more": "更多...",
  "hero.hot": "热门推荐",
  "hero.read": "立即阅读",
  "section.hot": "热门漫画",
  "section.latest": "最近更新",
  "section.ranking": "人气排行榜",
  "section.related": "相关推荐",
  "category.all": "全部",
  "category.romance": "恋爱",
  "category.action": "动作",
  "category.fantasy": "奇幻",
  "category.mystery": "悬疑",
  "category.comedy": "搞笑",
  "category.sliceOfLife": "日常",
  "category.drama": "剧情",
  "category.horror": "恐怖",
  "category.blgl": "BL/GL",
  "sort.latest": "最新",
  "sort.hot": "最热",
  "sort.rating": "评分",
  "sort.asc": "正序",
  "sort.desc": "倒序",
  "status.serializing": "连载中",
  "status.completed": "已完结",
  "comic.author": "作者",
  "comic.category": "分类",
  "comic.rating": "评分",
  "comic.views": "阅读",
  "comic.chapters": "章节列表",
  "comic.read": "开始阅读",
  "comic.tags": "标签",
  "about.title": "关于我们",
  "about.story": "品牌故事",
  "about.reviews": "用户口碑",
  "about.faq": "常见问题",
  "about.contact": "联系我们",
  "footer.copyright": "哈哈漫画网 版权所有",
  "footer.links": "友情链接",
};